var React = require('react');

function NonEngineering (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#6C6B6B","d":"M29 17c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6ZM9 7c-1.10457 0-2 .89543-2 2v10h12V7H9ZM19 21H7v10c0 1.1046.89543 2 2 2h10V21ZM21 21h12v10c0 1.1046-.8954 2-2 2H21V21Z"}));
}

NonEngineering.defaultProps = {"fill":"none","viewBox":"0 0 40 40"};

module.exports = NonEngineering;

NonEngineering.default = NonEngineering;
